var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    fill: "#3875EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.93036V11.5H7.25373V19H10.6005V11.5H12.5838L12.6883 9.03393H10.4943V7.64107C10.4943 6.89643 10.5935 6.56964 11.5391 6.56964H13V4H10.4943C8.25323 4 7.25547 5.025 7.25547 7.32321V8.93036H6Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.606a05fb9dd9bdbcc40a3524dea42283.svg";
export { ForwardRef as ReactComponent };